import { EvtStatsCard } from "components/stats/display-card";
import { EvtStatsCardPlaceholder } from "components/stats/placeholder";
import QueryError from "components/query-error";
import React from "react";
import { formatHoursToTime } from "components/timesheet/utils";
import { useMilestoneBillableHours } from "components/milestone/stats/billable/useMilestoneBillableHours";

export const MilestoneBillableHoursStat = ({ id }) => {
  const { data, isLoading, isError, refetch } =
    useMilestoneBillableHours(id);

  if (isLoading) {
    return <EvtStatsCardPlaceholder />;
  }

  if (isError) {
    return (
      <QueryError message="Failed to load Billable hours." onRetry={refetch} />
    );
  }

  return <EvtStatsCard label="Billable" value={formatHoursToTime(data)} />;
};
